module.exports = __webpack_public_path__ + "static/media/logo-black.bdb06b6b.png";